import { useEffect, useState } from "react";
import styled from "styled-components";
import Countdown from "react-countdown";
import { Button, CircularProgress, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { BrowserView, MobileView } from "react-device-detect";

import * as anchor from "@project-serum/anchor";

import { LAMPORTS_PER_SOL } from "@solana/web3.js";

import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";

import {
  CandyMachine,
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
  shortenAddress,
} from "./candy-machine";

const ConnectButton = styled(WalletDialogButton)``;

const CounterText = styled.span``; // add your styles here

const MintContainer = styled.div`
  width: 100%;
  height: 200px;
`; // add your styles here

const MintButton = styled(Button)``; // add your styles here

const HeaderDiv = styled.div`
  width: 100%;
  height: 100px;
`;

const HeaderDiv2 = styled.div`
  width: 100%;
  height: 50px;
`;

export interface HomeProps {
  candyMachineId: anchor.web3.PublicKey;
  config: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  treasury: anchor.web3.PublicKey;
  txTimeout: number;
}

const Home = (props: HomeProps) => {
  const [balance, setBalance] = useState<number>();
  const [isActive, setIsActive] = useState(false); // true when countdown completes
  const [isSoldOut, setIsSoldOut] = useState(false); // true when items remaining is zero
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT
  const heigth = window.innerHeight;

  const [itemsAvailable, setItemsAvailable] = useState(0);
  const [itemsRedeemed, setItemsRedeemed] = useState(0);
  const [itemsRemaining, setItemsRemaining] = useState(0);

  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const [startDate, setStartDate] = useState(new Date(props.startDate));

  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState<CandyMachine>();

  const refreshCandyMachineState = () => {
    (async () => {
      if (!wallet) return;

      const {
        candyMachine,
        goLiveDate,
        itemsAvailable,
        itemsRemaining,
        itemsRedeemed,
      } = await getCandyMachineState(
        wallet as anchor.Wallet,
        props.candyMachineId,
        props.connection
      );

      setItemsAvailable(itemsAvailable);
      setItemsRemaining(itemsRemaining);
      setItemsRedeemed(itemsRedeemed);

      setIsSoldOut(itemsRemaining === 0);
      setStartDate(goLiveDate);
      setCandyMachine(candyMachine);
    })();
  };

  const onMint = async () => {
    try {
      setIsMinting(true);
      if (wallet && candyMachine?.program) {
        const mintTxId = await mintOneToken(
          candyMachine,
          props.config,
          wallet.publicKey,
          props.treasury
        );

        const status = await awaitTransactionSignatureConfirmation(
          mintTxId,
          props.txTimeout,
          props.connection,
          "singleGossip",
          false
        );

        if (!status?.err) {
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
          });
        } else {
          setAlertState({
            open: true,
            message: "Mint failed! Please try again!",
            severity: "error",
          });
        }
      }
    } catch (error: any) {
      // TODO: blech:
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          setIsSoldOut(true);
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
      setIsMinting(false);
      refreshCandyMachineState();
    }
  };

  useEffect(() => {
    (async () => {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
    })();
  }, [wallet, props.connection]);

  useEffect(refreshCandyMachineState, [
    wallet,
    props.candyMachineId,
    props.connection,
  ]);
  

  return (
    <>
    
      <BrowserView>
        <main style={{backgroundColor: "#1a153a", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>

          <HeaderDiv style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
            <p style={{fontFamily: "Inconsolata Medium", fontSize: 72, color: "white"}}>Quokka Qommunity</p>
          </HeaderDiv>

          <HeaderDiv2 style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
            <p style={{fontFamily: "Inconsolata Medium", fontSize: 48, color: "white"}}>Minting Page</p>
          </HeaderDiv2>
          
          <HeaderDiv style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
            <Countdown
              date={1640671200000}
              onTick={renderCounter}
              onMount={({ completed }) => completed && setIsActive(true)}
              onComplete={() => setIsActive(true)}
              renderer={renderCounter}
            />
          </HeaderDiv>

          
          <MintContainer style={{justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column"}}>

            <p style={{fontFamily: "Inconsolata Light", fontSize: 20, color: "white"}}>Mint Cost: 0.5 SOL</p> 

            {wallet ?
            <p style={{fontFamily: "Inconsolata Light", fontSize: 20, color: "white"}}>{itemsRedeemed}/{itemsAvailable}</p> 
            : <></>}
            {!wallet ? (
              <ConnectButton style={{backgroundColor: "#7435a8", fontFamily: "Inconsolata Light"}}>CONNECT WALLET</ConnectButton>
            ) : (
              <MintButton
                disabled={isSoldOut || isMinting || !isActive}
                onClick={onMint}
                variant="contained"
                style={{backgroundColor: "#7435a8", width: 140, height: 50, justifyContent: "center", alignItems: "center"}}
              >
                {isSoldOut ? (
                  <p style={{color: "white", fontSize: 17.6, fontFamily: "Inconsolata Light"}}>SOLD OUT</p>
                ) : isActive ? (
                  isMinting ? (
                    <CircularProgress />
                  ) : (
                    <p style={{color: "white", fontSize: 17.6, fontFamily: "Inconsolata Light"}}>MINT</p>
                  )
                ) : (
                  <p style={{color: "white", fontSize: 17.6, fontFamily: "Inconsolata Light"}}>NOT ACTIVE</p>
                )}
              </MintButton>
            )}
          </MintContainer>

          <Snackbar
            open={alertState.open}
            autoHideDuration={6000}
            onClose={() => setAlertState({ ...alertState, open: false })}
          >
            <Alert
              onClose={() => setAlertState({ ...alertState, open: false })}
              severity={alertState.severity}
            >
              {alertState.message}
            </Alert>
          </Snackbar>
        </main>
      </BrowserView>
    
      <MobileView>
      <main style={{backgroundColor: "#1a153a", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>

        <HeaderDiv style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
          <p style={{fontFamily: "Inconsolata Medium", fontSize: 56, color: "White"}}>Qukka Qommunity</p>
        </HeaderDiv>

        <HeaderDiv2 style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
          <p style={{fontFamily: "Inconsolata Medium", fontSize: 36, color: "white"}}>Minting Page</p>
        </HeaderDiv2>

        <HeaderDiv style={{justifyContent: "center", alignItems: "center", display: "flex", width: "80%"}}>
          <Countdown
            date={1640671200000}
            onTick={renderMobileCounter}
            onMount={({ completed }) => completed && setIsActive(true)}
            onComplete={() => setIsActive(true)}
            renderer={renderMobileCounter}
          />
        </HeaderDiv>


        <MintContainer style={{justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column"}}>

          <p style={{fontFamily: "Inconsolata Light", fontSize: 20, color: "#e83e8c"}}>Mint Cost: 0.5 SOL</p> 

          {wallet ?
            <p style={{fontFamily: "Inconsolata Light", fontSize: 20, color: "#e83e8c"}}>{itemsRedeemed}/{itemsAvailable}</p> 
          : <></>}

          {!wallet ? (
            <ConnectButton style={{backgroundColor: "#e83e8c", fontFamily: "Inconsolata Light"}}>CONNECT WALLET</ConnectButton>
          ) : (
            <MintButton
              disabled={isSoldOut || isMinting || !isActive}
              onClick={onMint}
              variant="contained"
              style={{backgroundColor: "#7435a8", width: 140, height: 50, justifyContent: "center", alignItems: "center"}}
            >
              {isSoldOut ? (
                <p style={{color: "white", fontSize: 17.6, fontFamily: "Inconsolata Light"}}>SOLD OUT</p>
              ) : isActive ? (
                isMinting ? (
                  <CircularProgress />
                ) : (
                  <p style={{color: "white", fontSize: 17.6, fontFamily: "Inconsolata Light"}}>MINT</p>
                )
              ) : (
                <p style={{color: "white", fontSize: 17.6, fontFamily: "Inconsolata Light"}}>NOT ACTIVE</p>
              )}
            </MintButton>
          )}
        </MintContainer>

        <Snackbar
          open={alertState.open}
          autoHideDuration={6000}
          onClose={() => setAlertState({ ...alertState, open: false })}
        >
          <Alert
            onClose={() => setAlertState({ ...alertState, open: false })}
            severity={alertState.severity}
          >
            {alertState.message}
          </Alert>
        </Snackbar>
        </main>
      </MobileView>

    </>
        
  );
};

interface AlertState {
  open: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error" | undefined;
}

function pad(d : any) {
  return (d < 10) ? '0' + d.toString() : d.toString();
}

const renderCounter = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <CounterText style={{color: "white", flexDirection: "row", display: "flex", width: "100vh", justifyContent: "center", alignItems: "end"}}>

      <p style={{fontSize: 48,  fontFamily: "Inconsolata Medium",height: 1, marginLeft: 25}}>{pad(days)}</p>
      <p style={{fontSize: 20, height: 5, fontFamily: "Inconsolata Light", marginLeft: 10, marginRight: 15}}>Days</p>

      <p style={{fontSize: 48,  fontFamily: "Inconsolata Medium", height: 1}}>{pad(hours)}</p>
      <p style={{fontSize: 20, height: 5, fontFamily: "Inconsolata Light", marginLeft: 10, marginRight: 15}}>Hours</p>
      
      <p style={{fontSize: 48,  fontFamily: "Inconsolata Medium", height: 1}}>{pad(minutes)}</p>
      <p style={{fontSize: 20, height: 5, fontFamily: "Inconsolata Light", marginLeft: 10, marginRight: 15}}>Minutes</p>
      
      <p style={{fontSize: 48,  fontFamily: "Inconsolata Medium", height: 1}}>{pad(seconds)}</p>
      <p style={{fontSize: 20, height: 5, fontFamily: "Inconsolata Light", marginLeft: 10}}>Seconds</p>
    </CounterText>
  );
};

const renderMobileCounter = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <CounterText style={{color: "#e83e8c", flexDirection: "row", display: "flex", width: "100vh", justifyContent: "center", alignItems: "end"}}>

      <p style={{fontSize: 32, fontFamily: "Inconsolata Medium",height: 1, marginLeft: 25}}>{pad(days)}</p>
      <p style={{fontSize: 12, fontFamily: "Inconsolata Light", marginLeft: 3, marginRight: 15, marginTop: 25}}>Days</p>

      <p style={{fontSize: 32, fontFamily: "Inconsolata Medium", height: 1}}>{pad(hours)}</p>
      <p style={{fontSize: 12, fontFamily: "Inconsolata Light", marginLeft: 3, marginRight: 15, marginTop: 25}}>Hours</p>
      
      <p style={{fontSize: 32, fontFamily: "Inconsolata Medium", height: 1}}>{pad(minutes)}</p>
      <p style={{fontSize: 12, fontFamily: "Inconsolata Light", marginLeft: 3, marginRight: 15, marginTop: 25}}>Minutes</p>
      
      <p style={{fontSize: 32, fontFamily: "Inconsolata Medium", height: 1}}>{pad(seconds)}</p>
      <p style={{fontSize: 12, fontFamily: "Inconsolata Light", marginLeft: 3, marginTop: 25}}>Seconds</p>
    </CounterText>
  );
};

export default Home;
